var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomePracticalAndQuiz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2440)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 75,
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 33,
    width: 68,
    height: 89,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 43C62 37.4772 66.4772 33 72 33H120C125.523 33 130 37.4772 130 43V51H62V43Z",
    fill: "#1C07C2",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 2.5,
    fill: "#C5CCFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 30,
    r: 2.5,
    fill: "#C5CCFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 30,
    r: 2.5,
    fill: "#C5CCFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 17,
    width: 96,
    height: 125,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 27C18 21.4772 22.4772 17 28 17H104C109.523 17 114 21.4772 114 27V42H18V27Z",
    fill: "#4F75FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 29.5,
    r: 2.5,
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 29.5,
    r: 2.5,
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 29.5,
    r: 2.5,
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 71,
    width: 54,
    height: 5,
    rx: 2.5,
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 92,
    width: 54,
    height: 5,
    rx: 2.5,
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 113,
    width: 54,
    height: 5,
    rx: 2.5,
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3981 77.36H30.3701L33.5381 68.48H35.4341L38.5901 77.36H36.5261L35.9021 75.488H33.0341L32.3981 77.36ZM34.2341 71.96L33.5981 73.856H35.3501L34.7141 71.96C34.6181 71.66 34.5101 71.312 34.4741 71.096C34.4381 71.3 34.3421 71.636 34.2341 71.96Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3278 119.664C31.6638 119.664 29.9958 117.9 29.9958 115.092C29.9958 112.32 31.7598 110.496 34.4118 110.496C36.6319 110.496 38.2278 111.768 38.5038 113.76H36.4518C36.1878 112.872 35.4318 112.368 34.3638 112.368C32.9238 112.368 32.0478 113.388 32.0478 115.08C32.0478 116.748 32.9358 117.792 34.3638 117.792C35.4558 117.792 36.2598 117.252 36.4998 116.376H38.5159C38.2038 118.356 36.5478 119.664 34.3278 119.664Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 103.97C100.74 103.97 90 114.71 90 127.97C90 141.23 100.74 151.97 114 151.97C127.26 151.97 138 141.23 138 127.97C138 114.71 127.26 103.97 114 103.97ZM126.75 140.69C119.7 147.71 108.3 147.71 101.28 140.69L114 127.97V109.97C118.62 109.97 123.21 111.74 126.72 115.25C133.77 122.27 133.77 133.67 126.75 140.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.72 115.25C123.21 111.74 118.62 109.97 114 109.97V127.97L101.28 140.69C108.3 147.71 119.7 147.71 126.75 140.69C133.77 133.67 133.77 122.27 126.72 115.25ZM114 97.97C97.44 97.97 84 111.41 84 127.97C84 144.53 97.44 157.97 114 157.97C130.56 157.97 144 144.53 144 127.97C144 111.41 130.56 97.97 114 97.97ZM114 151.97C100.74 151.97 90 141.23 90 127.97C90 114.71 100.74 103.97 114 103.97C127.26 103.97 138 114.71 138 127.97C138 141.23 127.26 151.97 114 151.97Z",
    fill: "#4F75FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 88.3334C31.3199 88.3334 28.3333 91.32 28.3333 95C28.3333 98.68 31.3199 101.667 34.9999 101.667C38.6799 101.667 41.6666 98.68 41.6666 95C41.6666 91.32 38.6799 88.3334 34.9999 88.3334ZM33.1933 97.86L30.7999 95.4667C30.5399 95.2067 30.5399 94.7867 30.7999 94.5267C31.0599 94.2667 31.4799 94.2667 31.7399 94.5267L33.6666 96.4467L38.2533 91.86C38.5133 91.6 38.9333 91.6 39.1933 91.86C39.4533 92.12 39.4533 92.54 39.1933 92.8L34.1333 97.86C33.8799 98.12 33.4533 98.12 33.1933 97.86Z",
    fill: "#FFC93C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePracticalAndQuiz);
export default __webpack_public_path__ + "static/media/home_practical_and_quiz.f327fd26a80b6b7a6b734df0e6bb554c.svg";
export { ForwardRef as ReactComponent };